/**
 * Creates a sortable image grid with children added to the end of the created grid.
 *
 * Example:
 * // images = [{ id: 'tempId', imageId: 'realIdFromAPI', file: File }];
 * <AddImages images={images}>
 *   <input type="file" accept="images/*" onChange={handleChange} />
 * </AddImages>
 */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ImageFromFile, ResponsiveImage, IconSpinner } from '../../components';
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// import { arrayMoveImmutable } from 'array-move';

//sortable import
// import { SortableContainer, SortableElement } from 'react-sortable-hoc';

// import { SortableContainer, SortableElement } from "react-sortable-hoc"

import css from './AddImages.css';
import RemoveImageButton from './RemoveImageButton';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { useDrag, useDrop } from "react-dnd";
import { drop } from 'lodash';
import { Opacity } from '@material-ui/icons';
// import { ProviderSaleDeclined } from '../BookingBreakdown/BookingBreakdown.example';

//sortable element
// const SortablePhoto = SortableElement(item => <ImageFromFile {...item} />);
// const ThumbnailWrapper = SortableContainer(({ items }) => (
//   <ImageFromFile photos={items} renderImage={props => <SortablePhoto {...props} />} />
// ));

const ThumbnailWrapper = props => {
  const { className, image, savedImageAltText, onRemoveImage, index, moveImage,key ,id} = props;
  console.log("this is the key",props);
  const handleRemoveClick = e => {
    e.stopPropagation();
    onRemoveImage(image.id);
  };
  
  const removeButton = image.imageId ? <RemoveImageButton onClick={handleRemoveClick} /> : null;
    const[correct, setCorrect]=useState(false)
    useEffect(() => {
      console.log('refreshed thumbnail');
    },[correct]);
    const [{ isDragging }, drag] = useDrag(() => ({
      type: "image",
      item: { index },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }));

    const [spec, dropRef] = useDrop(() => ({
      accept: "image",
      drop: (item, isOver) =>{moveImage(item.index,index);},//item.props.id),
      
      hover: (item, monitor) => {
       
    },
    }));
    const ref = useRef(null)
    const dragDropRef = drag(dropRef(ref))
  if (image.file) {
    // Add remove button only when the image has been uploaded and can be removed
    const removeButton = image.imageId ? <RemoveImageButton onClick={handleRemoveClick} /> : null;
    
    // While image is uploading we show overlay on top of thumbnail
    const uploadingOverlay = !image.imageId ? (
      <div className={css.thumbnailLoading}>
        <IconSpinner />
      </div>
    ) : null;

    return (
      <ImageFromFile
        id={image.id}
        className={className}
        rootClassName={css.thumbnail}
        file={image.file}
      >
        {removeButton}
        {uploadingOverlay}
      </ImageFromFile>
    );
  } else {
    const classes = classNames(css.thumbnail, className);
    return (
      <div className={classes}>
        <div className={css.threeToTwoWrapper} 
                    style={{ border: isDragging ? "5px solid #eb7242" : "0px", zIndex:'1px',  opacity: isDragging? '0':'100%'}} 
                    ref={dragDropRef}
                    id={`${image.id.uuid}`}>
          <div ref={props.innerRef} className={css.aspectWrapper}>
           {/* <Draggable draggableId ={`${image.id.uuid}`} index={index}>

              {(provided) => (
                <div ref={provided.innerRef}  {...provided.dragHandleProps} {...provided.draggableProps}
                >
                  <ResponsiveImage
                    rootClassName={css.rootForImage}
                    image={image}
                    index={index}
                    alt={savedImageAltText}
                    variants={['landscape-crop', 'landscape-crop2x']}
                  />
                </div>

              )}

              </Draggable>*/}

                  <ResponsiveImage
                    rootClassName={css.rootForImage}
                    image={image}
                    index={index}
                    alt={savedImageAltText}
                    variants={['landscape-crop', 'landscape-crop2x']}
                  />

          </div>
          <RemoveImageButton onClick={handleRemoveClick} />
        </div>
      </div>
    );
  }
};

ThumbnailWrapper.defaultProps = { className: null };

const { array, func, node, string, object } = PropTypes;

ThumbnailWrapper.propTypes = {
  className: string,
  image: object.isRequired,
  savedImageAltText: string.isRequired,
  onRemoveImage: func.isRequired,
};

const AddImages = props => {
  //useState
  // const [items, setItems] = useState(images);

  // const onSortEnd = ({ oldIndex, newIndex }) => {
  //   setItems(arrayMoveImmutable (items, oldIndex, newIndex));
  // };
  const {
    children,
    className,
    thumbnailClassName,
    images,
    savedImageAltText,
    onRemoveImage,
    innerRef,
    provided,
    doneAndSwitch
  } = props;
  const classes = classNames(css.root, className);
  const [moved, setMoved]=useState(0)
  const [board, setBoard]= useState([]);

  useEffect(() => {
    console.log('New board!!!!!', board);
  },[board]);

 /*const [{ isOver }, drop] = useDrop(() => ({
    accept: "image",
    drop: (item, isOver) => moveImage(item, isOver),//item.props.id),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
    hover: (item, monitor) => {
      console.log(item);
      console.log(1);}
  }));*/
 

  const moveImage =useCallback( (Dragged, Hovered) =>{
    console.log('Images inside?', images);
    const newImages=doneAndSwitch(Dragged,Hovered)
    console.log('Images changed?', newImages);
    setBoard([])
    setBoard(newImages.map((image, i) =>{
      return(
        <ThumbnailWrapper
        // items={items}
        // onSortEnd={onSortEnd}
        // axis={'xy'}
        moveImage={moveImage}
        id={i}
        innerRef={innerRef}
        provided={provided}
        image={image}
        index={i}
        key={image.id.uuid || image.id}
        className={thumbnailClassName}
        savedImageAltText={savedImageAltText}
        onRemoveImage={onRemoveImage}
      />
      )
    }));
    console.log('Thumbnailnumber',board)
    /*const piclist = board.filter((picture) => {console.log('Thumbnailnumber',Dragged == picture.props.index);return Dragged === picture.props.index});
    console.log('Thumbnailnumber4',piclist);
    var tempId=piclist[0].props.id
    var temp= {
      ...piclist[0],
      props:{
        ...piclist[0].props,
        id:Hovered,
        index:Hovered
      },
    }
    
    var newBoard=board;
    

    var k=newBoard[Hovered]

    var replaced={
      ...k,
      props:{
        ...k.props,
        id:Dragged,
        index:Dragged
      }
    }
    newBoard[Dragged]=replaced
    newBoard[Hovered]=temp
    console.log("Actual New Board",newBoard);
    setBoard(board =>{
      var b=[...board]
      b[Dragged]=replaced
      b[Hovered]=temp
      return b
    }, [board],);
    console.log('images',images);*/
    
  });
  useEffect(() =>{
    setBoard(images.map((image, i) =>{
      return(
        <ThumbnailWrapper
        // items={items}
        // onSortEnd={onSortEnd}
        // axis={'xy'}
        moveImage={moveImage}
        id={i}
        innerRef={innerRef}
        provided={provided}
        image={image}
        index={i}
        key={image.id.uuid || image.id}
        className={thumbnailClassName}
        savedImageAltText={savedImageAltText}
        onRemoveImage={onRemoveImage}
      />
      )
    }));
  }, [images]);
  

  return (
    <div className={classes} ref={drop}>
      {/*images.map((image, index) => {
        return (
          <ThumbnailWrapper
            // items={items}
            // onSortEnd={onSortEnd}
            // axis={'xy'}
            moveImage={moveImage}
            innerRef={innerRef}
            provided={provided}
            image={image}
            index={index}
            key={image.id.uuid || image.id}
            className={thumbnailClassName}
            savedImageAltText={savedImageAltText}
            onRemoveImage={onRemoveImage}
          />
        );
      })*/}
      {board}
      {children}

      {/* <h1>Test</h1> */}
    </div>
  );
};

AddImages.defaultProps = { className: null, thumbnailClassName: null, images: [] };

AddImages.propTypes = {
  images: array,
  children: node.isRequired,
  className: string,
  thumbnailClassName: string,
  savedImageAltText: string.isRequired,
  onRemoveImage: func.isRequired,
};

export default AddImages;